import { refreshAccessToken } from './authSession';

export const headersWithAccessToken = (headers, accessToken) => {
  const normalizedHeaders = Object.fromEntries(new Headers(headers || {}).entries());
  if (accessToken) {
    normalizedHeaders.Authorization = `Bearer ${accessToken}`;
  }
  return normalizedHeaders;
};

export const authenticatedFetch = async (
  input,
  init = {},
  { fetchImpl = fetch } = {}
) => {
  const accessToken = typeof localStorage !== 'undefined'
    ? localStorage.getItem('accessToken')
    : null;
  const requestInit = {
    ...init,
    headers: headersWithAccessToken(init.headers, accessToken)
  };
  const response = await fetchImpl(input, requestInit);

  if (response.status !== 401) return response;

  const refreshedAccessToken = await refreshAccessToken(accessToken);
  return fetchImpl(input, {
    ...init,
    headers: headersWithAccessToken(init.headers, refreshedAccessToken)
  });
};
